import { Typography, Button, Dialog } from '~/UIKit';
import React from 'react';
import { CHARCOAL_GREY } from '../../Constants/Colors.constants';
import { useLanguage } from '../../Hooks';
import { makeStyles } from '~/UIKit/Style';
import { useClaimManagerModal } from './useClaimManagerModal';

const useStyles = makeStyles({
  managerDialog: {
    display: 'flex',
    flexDirection: 'column',
    padding: '60px 30px',
    height: '100%',
  },
  managerDialogInfo: {
    marginBottom: 40,
    textAlign: 'center',
  },
  managerDialogTitle: {
    fontSize: 22,
    fontWeight: 'bold',
    lineHeight: '34px',
    letterSpacing: '0.5px',
    color: CHARCOAL_GREY,
    marginBottom: 30,
  },
  managerDialogContent: {
    fontSize: 16,
    lineHeight: '27px',
    letterSpacing: '0.5px',
  },
  managerDialogContinueBtn: {
    marginBottom: 30,
    textAlign: 'center',
  },
  managerDialogProvider: {
    fontWeight: 'bold',
  },
});

export interface ClaimManagerModalContainerProps {
  onRightsGranted: (granted: boolean) => void;
}

export const ClaimManagerModal = ({ onRightsGranted }: ClaimManagerModalContainerProps) => {
  const { t } = useLanguage();
  const { classes } = useStyles();
  const {
    hasAccess,
    onClaimRightsConfirm,
    onClose,
    providerName,
    isMobile,
    DANGEROUSLY_isSuperAdmin,
    isLoading,
  } = useClaimManagerModal({ onRightsGranted });

  if (hasAccess || !DANGEROUSLY_isSuperAdmin || isLoading) return null;

  return (
    <Dialog fullScreen={isMobile} onClose={onClose} open>
      <div className={classes.managerDialog}>
        <div className={classes.managerDialogInfo}>
          <Typography className={classes.managerDialogTitle} data-testid="ClaimManagerTitle">
            {t('app.temp.manager')}
          </Typography>
          <Typography className={classes.managerDialogContent}>
            {t('app.temp.manager.info')}
          </Typography>
          <Typography
            className={classes.managerDialogProvider}
            data-testid="ClaimManagerProviderName"
          >
            {providerName}
          </Typography>
          <Typography>{t('app.temp.manager.info2')}</Typography>
        </div>
        <Button
          className={classes.managerDialogContinueBtn}
          color="primary"
          onClick={onClaimRightsConfirm}
          variant="contained"
        >
          {t('app.continue')}
        </Button>
        <Button color="primary" onClick={onClose}>
          {t('app.cancel')}
        </Button>
      </div>
    </Dialog>
  );
};
